import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import moment from "moment";

function Galeri() {
    const navigate = useNavigate();

    //define state
    const [galeri, setGaleri] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/galery/readGaleri`);
            // get response data
            const data = response.data;
            // assign response data to state "Customer"
            setGaleri(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error, e.g., show a galeri-friendly message
        }
    };

    useEffect(() => {
        //panggil method "fetchData"
        fetchData();
    }, []);

    const handleDelete = async (id_galeri) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Make axios delete request
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/galery/deleteGaleri/${id_galeri}`
                    );

                    // Refetch data after successful delete
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Title Foto 1",
            selector: (row) => row.title_foto_satu,
            sortable: true,
        },
        {
            name: "Foto 1",
            selector: (row) => (
                <img
                    src={
                        row.foto_satu.startsWith("http")
                            ? row.foto_satu
                            : `${process.env.REACT_APP_API_URL}/galery/uploads/${row.foto_satu}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Title Foto 2",
            selector: (row) => row.title_foto_dua,
            sortable: true,
        },
        {
            name: "Foto 2",
            selector: (row) => (
                <img
                    src={
                        row.foto_dua.startsWith("http")
                            ? row.foto_dua
                            : `${process.env.REACT_APP_API_URL}/galery/uploads/${row.foto_dua}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Title Foto 3",
            selector: (row) => row.title_foto_tiga,
            sortable: true,
        },
        {
            name: "Foto 3",
            selector: (row) => (
                <img
                    src={
                        row.foto_tiga.startsWith("http")
                            ? row.foto_tiga
                            : `${process.env.REACT_APP_API_URL}/galery/uploads/${row.foto_tiga}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Group",
            selector: (row) => row.group_galeri,
            sortable: true,
        },
        {
            name: "Tanggal",
            selector: (row) => moment(row.tanggal).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/galeriEdit/${row.id_galeri}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id_galeri)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">galeri</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Galeri</h3>
                                    </div>
                                    <div className="card-body">
                                        <Link to="/galeriAdd" className="btn btn-primary">
                                            <i className="nav-icon fas fa-plus mr-2" />
                                            Add Data
                                        </Link>
                                        <DataTable columns={columns} data={galeri} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Galeri;
